import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';

import { AngularMaterialCommonModule } from '@app/shared/angular-material/angular-material-common.module';
import {
  menuGroupFeatures,
  MenuGroupsEnum,
  MenuItemTitleEnum
} from '@app/shared/components/navigation/navigation-components.model';
import { NavigationComponentsService } from '@app/shared/components/navigation/navigation-components.service';
import { PlanDataEnum } from '@app/plan/plan.model';
import { PlanService } from '@app/plan/plan.service';
import { FEAT_TITLE, FeatureEnum } from '@app/plan-manager/plan-manager.model';
import { PlanManagerService } from '@app/plan-manager/plan-manager.service';

import { floatingMenuAnimation } from '../floating-menu.constants';

@Component({
  selector: 'app-mobile-bottom-navigation-floating-menu',
  templateUrl: './mobile-bottom-navigation-floating-menu.component.html',
  styleUrl: './mobile-bottom-navigation-floating-menu.component.scss',
  animations: [floatingMenuAnimation],
  imports: [CommonModule, AngularMaterialCommonModule]
})
export class MobileBottomNavigationFloatingMenuComponent
  implements OnInit, OnChanges
{
  feature = FeatureEnum;
  menuGroupsEnum = MenuGroupsEnum;
  menuItemTitleEnum = MenuItemTitleEnum;
  featTitle = FEAT_TITLE;

  @Input({ required: true }) isVisible: boolean;
  @Output() onClose = new EventEmitter<void>();

  menuGroupData = {
    isOpened: false,
    title: '',
    features: [] as FeatureEnum[]
  };

  isSinglePlan: boolean;

  constructor(
    private planService: PlanService,
    private planManagerService: PlanManagerService,
    private navigationComponentsService: NavigationComponentsService
  ) {}

  get selectedPlanData$() {
    return this.planManagerService.getSelectedPlanData;
  }

  ngOnInit(): void {
    this.isSinglePlan = Boolean(
      this.planService.getPlanData(PlanDataEnum.SinglePlan)
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { isVisible } = changes;

    if (!isVisible.currentValue) {
      this.closeMenuGroup();
    }
  }

  openMenuGroup(menuGroup: MenuGroupsEnum, featList: FeatureEnum[]) {
    let features = menuGroupFeatures[menuGroup].filter((feat: FeatureEnum) =>
      this.hasFeatOn(feat, featList)
    ) as FeatureEnum[];
    const title = MenuItemTitleEnum[menuGroup];

    if (menuGroup === MenuGroupsEnum.MANAGE_PLANS) {
      features = this.removeBalanceFromManagePlanGroup(features);
    }

    this.menuGroupData = {
      isOpened: true,
      title,
      features
    };
  }

  closeMenuGroup() {
    this.menuGroupData = {
      isOpened: false,
      title: '',
      features: []
    };
  }

  hasFeatOn(feature: FeatureEnum, featList: FeatureEnum[]): boolean {
    return this.planManagerService.hasFeatOn(feature, featList);
  }

  navigateTo(url: string) {
    this.onClose.emit();
    this.navigationComponentsService.navigateTo(url);
  }

  handleNavigationItemAction(feature: FeatureEnum, registration: string) {
    this.onClose.emit();
    this.navigationComponentsService.featAction(feature, registration);
  }

  removeBalanceFromManagePlanGroup(features: FeatureEnum[]) {
    return features.filter((feature) => feature !== FeatureEnum.BALANCE);
  }
}
